import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=369cdb2a&scoped=true"
import script from "./Index.ts?vue&type=script&lang=js&external"
export * from "./Index.ts?vue&type=script&lang=js&external"
import style0 from "./Index.less?vue&type=style&index=0&id=369cdb2a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369cdb2a",
  null
  
)

export default component.exports